import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../Icon/Icon";
import "./SearchBox.css";

export const SearchBox = ({ searchTerm, setSearchTerm }) => {
  const { t } = useTranslation();
  return (
    <div className="SearchBox">
      <input
        className="SearchBox__input"
        value={searchTerm}
        placeholder={t("generic.searchPlaceholder")}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div className="SearchBox__icon">
        <Icon name="iconSearch" width={20} />
      </div>
    </div>
  );
};
